import React from 'react';
import styled, { ThemeProvider } from 'styled-components';

import { colorThemeGenerator } from '@spotify-internal/encore-creator-web';
import { black, kleinBlue } from '@spotify-internal/encore-foundation';

const resetComponents = {
  app: '',
  table: '',
  tableRow: '',
  buttonIcon: '',
  loadingIndicator: '',
  navBar: '',
  navBarList: '',
  navBarListItem: '',
  dialogAlert: '',
  dialogConfirmation: '',
  formGroup: '',
  formInput: '',
  button: '',
  type: '',
};

const Wrapper = styled.div`
  --primaryColor: ${({ theme }) => theme.colors.primaryColor};
  color: ${black};
`;

const lightTheme = {
  ...resetComponents,
  ...colorThemeGenerator({ primaryColor: kleinBlue }),
};

type Props = {
  children?: JSX.Element;
};

export function ResetLightTheme({ children }: Props) {
  return (
    <ThemeProvider theme={lightTheme}>
      <Wrapper>{children}</Wrapper>
    </ThemeProvider>
  );
}
